




































































import Vue from "vue";
import store from "@/store";

// Interfaces
import { Workout } from "@/interfaces/workout.interface";

// Components
import CurrentWorkoutDialog from "@/components/dialogs/CurrentWorkoutDialog.vue";
import { secondsToTime } from "@/interfaces/time.interface";
import moment from "moment";

export default Vue.extend({
  data: () => {
    return {
      showExtraDetails: false,
      firebaseTimer: 0,
      workoutTimer: 0,
      timeWorkingOut: "0:00",
    };
  },
  mounted() {
    this.firebaseTimer = setInterval(async () => {
      console.log("Sending Updated Workout To Firebase");
      console.log(this.getCurrentWorkout);

      if (this.getCurrentWorkout)
        await store
          .dispatch("workoutStore/updateCurrentWorkout", this.getCurrentWorkout)
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.error(err);
          });
    }, 60000);
    this.workoutTimer = setInterval(() => {
      if (this.getCurrentWorkout) {
        this.timeWorkingOut = secondsToTime(
          moment().unix() - this.getCurrentWorkout.startTime,
          false,
          true
        );
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.firebaseTimer);
    clearInterval(this.workoutTimer);
  },
  methods: {
    openUpWorkoutDialog() {
      store.commit("workoutStore/changeCurrentWorkoutDialogCollapse", true);
    },
  },
  computed: {
    getCurrentWorkout(): Workout | null {
      return store.getters["workoutStore/getCurrentWorkout"];
    },
    bestExerciseSets(): string[] {
      let bestSetList: string[] = [];
      let workoutData: Workout | null =
        store.getters["workoutStore/getCurrentWorkout"];
      if (workoutData == null) return [];

      if (workoutData.exercises) {
        workoutData.exercises.forEach((exercise) => {
          let bestSet = {
            output: "",
            calculated: 0,
          };

          let weightedSets = [
            "Barbell",
            "Dumbbell",
            "Machine",
            "Weighted Bodyweight",
            "Assisted Bodyweight",
          ];

          if (weightedSets.includes(exercise.type)) {
            if (exercise.sets[0].weight && exercise.sets[0].reps) {
              bestSet.output = `${exercise.sets[0].weight} x ${exercise.sets[0].reps}`;
              bestSet.calculated =
                exercise.sets[0].weight * exercise.sets[0].reps;
            }
          }

          if (exercise.sets.length > 0) {
            exercise.sets.forEach((set) => {
              if (weightedSets.includes(exercise.type)) {
                if (set.weight && set.reps) {
                  if (set.weight * set.reps > bestSet.calculated) {
                    bestSet.output = `${set.weight} x ${set.reps}`;
                    bestSet.calculated = set.weight * set.reps;
                  }
                }
              }
            });
          }
          if (bestSet.output === "") bestSet.output = "No Sets";

          bestSetList.push(`${exercise.exerciseName}: ${bestSet.output}`);
        });
      }

      return bestSetList;
    },
    isUserCurrentlyWorkingOut(): boolean {
      return store.getters["workoutStore/isUserCurrentlyWorkingOut"];
    },
  },
  components: {
    CurrentWorkoutDialog,
  },
});
